import Vue from 'vue'
import Vuex from 'vuex'
import cloud from './modules/cloud'
import common from './modules/common'
import mine from './modules/mine'
import user from './modules/user'
import vip from './modules/vip'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    cloud,
    common,
    mine,
    user,
    vip
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js